var _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMetricsFluor = function SvgMetricsFluor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.48 10.193 7.635 7.635l2.558 9.845zm20.893 8.654v10.306L47.144 24zm-.566-1.367 2.558-9.845-9.846 2.558zm-8.654-7.853L24 .856l-5.153 8.771zm-19.526 9.22L.856 24l8.771 5.153zm20.892 18.96 9.846 2.558-2.558-9.845zm-11.672.566L24 47.144l5.153-8.771zm-8.654-7.853-2.558 9.845 9.845-2.558zm18.524-17.907h-9.434l-6.67 6.67v9.434l6.67 6.67h9.434l6.67-6.67v-9.434z"
  })))));
};
export default SvgMetricsFluor;